import * as React from 'react';

import * as styles from './col.scss';

type Props = {
    className?: string;
};

const Col: React.SFC<Props> = props => {
    const className = props.className || '';
    const classes = className + ' ' + styles.col;
    return <div className={classes}>{props.children}</div>
};


export default Col;